import React, {FC} from 'react';
import styled from 'styled-components';

import {PaletteColorsEnum} from '../../../../libs/shared/core/src/models/api/paletteModel';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {center} from '../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface ApplicationCardInitialsAvatarProps {
  name: string;
  color: PaletteColorsEnum;
  size: VisualSizesEnum;
}

/*
 * Style.
 */

interface AvatarStyleProps {
  $color: PaletteColorsEnum;
  $size: VisualSizesEnum;
}
const StyledAvatarDiv = styled.div<AvatarStyleProps>`
  align-self: center;
  width: ${(p) => computeStyledAvatarDimensions(p.$size)};
  height: ${(p) => computeStyledAvatarDimensions(p.$size)};
  ${center()}

  border-radius: 15px 15px;
  background-color: ${(p) => p.theme.palette[p.$color].shade40};
`;

interface StyledInitialDivProps {
  $size?: VisualSizesEnum;
}
const StyledInitialDiv = styled.div<StyledInitialDivProps>`
  margin-bottom: 1px;

  color: ${(p) => p.theme.greys.white};
  font-size: ${(p) => computeStyledInitialFontSize(p.$size)};
  font-weight: ${fontWeights.bold};
  text-transform: uppercase;
`;

function computeStyledAvatarDimensions(size: VisualSizesEnum | undefined) {
  switch (size) {
    case VisualSizesEnum.SMALL:
      return `12px`;
    case VisualSizesEnum.MEDIUM:
      return `16px`;
    default:
      return `30px`;
  }
}

function computeStyledInitialFontSize(size: VisualSizesEnum | undefined) {
  switch (size) {
    case VisualSizesEnum.SMALL:
      return fontSizes.veryTiny;
    case VisualSizesEnum.MEDIUM:
      return fontSizes.verySmall;
    default:
      return fontSizes.veryLarge;
  }
}

/*
 * Component.
 */

export const ApplicationCardInitialsAvatar: FC<ApplicationCardInitialsAvatarProps> = (props) => {
  const {name, color, size} = props;
  return (
    <StyledAvatarDiv $color={color} $size={size}>
      <StyledInitialDiv $size={size}>{name[0] || 'P'}</StyledInitialDiv>
    </StyledAvatarDiv>
  );
};
